import * as React from 'react';
import CopyrightIcon from '@mui/icons-material/Copyright';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { usePrimaryEffectEnhancement } from '../../style/global/theme';

const publicLogoPath = '/TELUS_2020_BIL_Digital_RGB.svg';

const StyledCopyRight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.2rem 0.5rem;
`;

const StyledCompany = styled.a`
  color: #4b286d;
  text-decoration: none;
`;

const StyledSVG = styled.img`
  height: 2rem;
  min-width: 5rem;
`;

const year = new Date().getFullYear();

const Footer = () => {
  const EnhancedTypographyStyle = usePrimaryEffectEnhancement({ fontSize: '0.7rem' });

  return (
    <StyledContainer>
      <StyledSVG alt="Logo" src={publicLogoPath} />
      <StyledCopyRight>
        <CopyrightIcon color="primary" />
        <StyledCompany href="http://telushealth.com" rel="noopener" target="_blank">
          <Typography sx={EnhancedTypographyStyle}>{year} TELUS</Typography>
        </StyledCompany>
      </StyledCopyRight>
    </StyledContainer>
  );
};

export default Footer;
